export default __webpack_public_path__ + "static/media/intro-encuesta.d4fe1546.png";